const STORAGE_KEY = 'gbrakes_vehicle_history';
const MAX_HISTORY_ITEMS = 5;

export interface SavedVehicle {
  makeName: string;
  makeSlug: string;
  modelName: string;
  modelSlug: string;
  year: string;
}

export function getSavedVehicles(): SavedVehicle[] {
  try {
    const item = window.localStorage.getItem(STORAGE_KEY);
    return item ? JSON.parse(item) : [];
  } catch (error) {
    console.error("Error reading vehicle history from localStorage", error);
    return [];
  }
}

export function addSavedVehicle(vehicle: SavedVehicle): void {
  const currentVehicles = getSavedVehicles();

  // Create a unique key for the vehicle to check for existence
  const vehicleKey = `${vehicle.makeSlug}-${vehicle.modelSlug}-${vehicle.year}`;

  // Check if the most recent vehicle is the same as the one being added.
  if (currentVehicles.length > 0) {
    const mostRecentVehicle = currentVehicles[0];
    const mostRecentKey = `${mostRecentVehicle.makeSlug}-${mostRecentVehicle.modelSlug}-${mostRecentVehicle.year}`;
    if (mostRecentKey === vehicleKey) {
      return; // It's already the most recent, do nothing.
    }
  }

  // Remove existing entry if it's the same to move it to the top
  const filteredVehicles = currentVehicles.filter(v => {
      const key = `${v.makeSlug}-${v.modelSlug}-${v.year}`;
      return key !== vehicleKey;
  });

  // Add the new vehicle to the beginning and trim the history to the max length
  const newHistory = [vehicle, ...filteredVehicles].slice(0, MAX_HISTORY_ITEMS);

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(newHistory));
  } catch (error) {
    console.error("Error saving vehicle history to localStorage", error);
  }
}

export function removeSavedVehicle(vehicleToRemove: Partial<SavedVehicle>): void {
  const currentVehicles = getSavedVehicles();
  const vehicleKeyToRemove = `${vehicleToRemove.makeSlug}-${vehicleToRemove.modelSlug}-${vehicleToRemove.year}`;
  const newHistory = currentVehicles.filter(v => {
    const key = `${v.makeSlug}-${v.modelSlug}-${v.year}`;
    return key !== vehicleKeyToRemove;
  });
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(newHistory));
  } catch (error) {
    console.error("Error removing vehicle from localStorage", error);
  }
}

// Attach to a global namespace to be accessible from inline scripts from PHP
declare global {
    interface Window {
        gbrakes?: {
            addSavedVehicle?: (vehicle: SavedVehicle) => void;
            // Keep other potential functions on the object
            [key: string]: any;
        };
    }
}

if (typeof window !== 'undefined') {
    if (!window.gbrakes) {
        window.gbrakes = {};
    }
    window.gbrakes.addSavedVehicle = addSavedVehicle;
}